import { render, staticRenderFns } from "./ClaimTypePropertyGroup.vue?vue&type=template&id=1506126e&"
import script from "./ClaimTypePropertyGroup.vue?vue&type=script&lang=js&"
export * from "./ClaimTypePropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1506126e')) {
      api.createRecord('1506126e', component.options)
    } else {
      api.reload('1506126e', component.options)
    }
    module.hot.accept("./ClaimTypePropertyGroup.vue?vue&type=template&id=1506126e&", function () {
      api.rerender('1506126e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimTypePropertyGroup/ClaimTypePropertyGroup.vue"
export default component.exports